// ══════════════════════════════════════════════════════
//  MEDIOS DE LA PORTADA (Cloudinary nuevo, carpeta web)
//  Todas las URL de la foto y el vídeo del Home viven aquí. Para cambiar la portada,
//  se cambia la versión/nombre en estas constantes y nada más.
//  Las variantes transformadas se comprobaron con HTTP 200 (peso aprox. entre paréntesis).
// ══════════════════════════════════════════════════════

const CLOUD = "https://res.cloudinary.com/srcml34f";
const FOTO = "v1792250012/homeplatotrasplato.jpg"; // original: 646 KB
const VIDEO = "v1792250013/videohomeplatotrasplato"; // original: 4,2 MB

const foto = (ancho) => `${CLOUD}/image/upload/f_auto,q_auto,w_${ancho}/${FOTO}`;
const video = (ancho, formato) =>
  `${CLOUD}/video/upload/${formato === "webm" ? "f_webm," : ""}q_auto,w_${ancho}/${VIDEO}.${formato}`;

export const PORTADA = {
  // Foto de portada y póster del vídeo
  fotoEscritorio: foto(1920), // ≈ 111 KB
  fotoMovil: foto(900), // ≈ 38 KB
  // Para compartir en redes (og:image de public/index.html)
  fotoCompartir: foto(1200), // ≈ 56 KB
  // Vídeo de 8 s: primero webm (más ligero), mp4 de reserva
  videoEscritorio: [
    { src: video(1280, "webm"), type: "video/webm" }, // ≈ 690 KB
    { src: video(1280, "mp4"), type: "video/mp4" }, // ≈ 1,2 MB
  ],
  videoMovil: [
    { src: video(720, "webm"), type: "video/webm" }, // ≈ 440 KB
    { src: video(720, "mp4"), type: "video/mp4" }, // ≈ 630 KB
  ],
};

// Foto de cada categoría en las tarjetas de móvil, fijada a mano: { salsa: "https://res.cloudinary.com/…" }.
// Las categorías que no estén aquí usan la foto de su receta mejor valorada (services/fotosCategoria.js).
export const FOTOS_CATEGORIA = {};

// Anchura (px) hasta la que se sirven las versiones de móvil
export const ANCHO_MOVIL = 768;
